import React, { useEffect, useState } from 'react';
import { X, ShoppingBag } from 'lucide-react';
const NOTIFICATIONS = [{
  name: 'Lina María F.',
  city: 'Medellín'
}, {
  name: 'Carolina G.',
  city: 'Bogotá'
}, {
  name: 'Andrea P.',
  city: 'Cali'
}, {
  name: 'Valentina R.',
  city: 'Barranquilla'
}, {
  name: 'Diana M.',
  city: 'Bucaramanga'
}, {
  name: 'Juliana C.',
  city: 'Pereira'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentNotif, setCurrentNotif] = useState(NOTIFICATIONS[0]);
  const [isDismissed, setIsDismissed] = useState(false);
  useEffect(() => {
    if (isDismissed) return;
    // Initial delay before first notification
    const initialTimeout = setTimeout(() => {
      showNotification();
    }, 15000);
    return () => clearTimeout(initialTimeout);
  }, [isDismissed]);
  const showNotification = () => {
    if (isDismissed) return;
    // Pick a random notification
    const randomNotif = NOTIFICATIONS[Math.floor(Math.random() * NOTIFICATIONS.length)];
    setCurrentNotif(randomNotif);
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
      // Schedule next notification between 25-45s
      if (!isDismissed) {
        const nextDelay = Math.floor(Math.random() * (45000 - 25000 + 1) + 25000);
        setTimeout(showNotification, nextDelay);
      }
    }, 5000);
  };
  if (!isVisible || isDismissed) return null;
  return <div className="fixed bottom-24 md:bottom-6 left-4 md:left-6 z-50 animate-slide-up max-w-sm w-[calc(100%-2rem)]" data-id="element-226">
      <div className="bg-white rounded-lg shadow-xl border border-warm-100 p-3 flex items-start gap-3 relative" data-id="element-227">
        <button onClick={() => {
        setIsVisible(false);
        setIsDismissed(true);
      }} className="absolute top-2 right-2 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-228">
          <X className="w-4 h-4" data-id="element-229" />
        </button>

        <div className="bg-primary/10 p-2 rounded-full shrink-0 mt-1" data-id="element-230">
          <ShoppingBag className="w-5 h-5 text-primary" data-id="element-231" />
        </div>

        <div data-id="element-232">
          <p className="text-sm text-charcoal font-medium pr-6" data-id="element-233">
            <span className="font-bold" data-id="element-234">{currentNotif.name}</span> de{' '}
            {currentNotif.city} acaba de comprar...
          </p>
          <p className="text-xs text-charcoal-muted mt-1" data-id="element-235">
            "Airfryer a la Colombiana"
          </p>
          <p className="text-xs text-trust font-medium mt-1" data-id="element-236">
            Hace unos segundos
          </p>
        </div>
      </div>
    </div>;
}